function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCoreTechnology = function SvgCoreTechnology(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Core Technology"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5,
      fill: "none"
    },
    d: "m125 161.18 35.71 18.77-6.82-39.76 28.89-28.16-39.93-5.8L125 70.05l-17.85 36.18-39.93 5.8 28.89 28.16-6.82 39.76L125 161.18z"
  })));
};

export default SvgCoreTechnology;